export const reservationConversations = {
  tabs: {
    calls: "المكالمات",
    web: "الويب",
    checkins: "تسجيلات الوصول",
    charges: "الرسوم",
    notes: "الملاحظات",
  },
  checkinBadge: {
    allCompleted: "اكتملت جميع تسجيلات الوصول",
    manuallyResolved: "أكمل أحد المشغّلين الإرسال النهائي يدويًا",
    progress: "{done}/{total} تسجيلات وصول مكتملة",
  },
  banners: {
    limitedMode:
      "هذا الحجز غير مهيّأ للتدفق الكامل. يمكنك استخدام WhatsApp والملاحظات الداخلية فقط.",
    rejectedMode:
      "تم رفض الطلب. لم يتبقَّ سوى WhatsApp والملاحظات الداخلية.",
    autoReplying: "الوكيل يردّ تلقائيًا.",
  },
  search: {
    placeholder: "ابحث بالاسم أو الهاتف أو رمز الحجز...",
  },
  list: {
    emptyTitle: "لا توجد محادثات بعد",
    emptyText:
      "عندما يكتب الضيف أو ترسل رسالة، ستظهر المحادثة هنا.",
    noResultsTitle: "لم يتم العثور على محادثات",
    noResultsText: "جرّب اسمًا أو هاتفًا أو رمز حجز آخر.",
    aiActiveTitle: "وكيل الذكاء الاصطناعي نشط",
    markAllRead: "تحديد الكل كمقروء",
  },
  conversation: {
    windowTimer: "نافذة الرسائل: {hours} ساعة متبقية",
    copyPortalCopied: "تم نسخ الرابط",
    copyPortalTooltip: "نسخ رابط الإدارة",
    copiedShort: "تم النسخ",
    copyLinkShort: "نسخ الرابط",
    dropToAttach: "أفلت لإرفاق الملفات",
    senderBot: "البوت / الطاقم",
    senderGuest: "الضيف",
    imageAlt: "صورة مُرسَلة",
    locationReceived: "تم استلام الموقع",
    viewFile: "عرض الملف",
    notSent: "لم يُرسَل",
    sending: "جارٍ الإرسال...",
    emptyTitle: "لا توجد رسائل بعد",
    emptyText:
      "ابدأ المحادثة بقالب أو انتظر حتى يكتب الضيف.",
  },
  mode: {
    ai: "ذكاء اصطناعي",
    manual: "يدوي",
    agentInactiveTooltip:
      "وكيل الذكاء الاصطناعي غير نشط لهذا العقار. فعّله من إعدادات القائمة ليردّ تلقائيًا.",
    agentInactiveChip: "وكيل الذكاء الاصطناعي غير نشط",
  },
  composer: {
    predefinedTitle: "الردود الجاهزة",
    predefinedEmpty: "لم يتم العثور على ردود جاهزة",
    attachFile: "إرفاق ملف",
    inputPlaceholder: "ابدأ بـ / لاختيار رد جاهز.",
    removeFile: "إزالة الملف",
    fileFallback: "ملف",
  },
  calls: {
    title: "مكالمات هذا الحجز",
    none: "لا توجد مكالمات مرتبطة بهذا الحجز.",
    caller: "المتصل",
    bookedFromCall: "تم الحجز من هذه المكالمة",
    pause: "إيقاف مؤقت",
    play: "تشغيل",
    downloadMp3: "تنزيل MP3",
    noRecording: "لا يوجد تسجيل",
  },
  ota: {
    noData: "لا توجد بيانات حجز لتحميل رسائل OTA.",
  },
  checkins: {
    title: "تسجيلات وصول الحجز",
  },
  charges: {
    title: "رسوم الحجز",
    noData: "لا توجد بيانات حجز لتحميل الرسوم.",
  },
  notes: {
    title: "ملاحظات داخلية",
    noData: "لا توجد بيانات حجز لتحميل الملاحظات.",
  },
  time: {
    today: "اليوم {time}",
    yesterday: "أمس {time}",
  },
  guestFallback: "ضيف",
  webGuestFallback: "ضيف",
  documentFallback: "مستند",
  location: {
    openInMaps: "افتح في Google Maps",
    viewCoords: "عرض الإحداثيات ({lat}، {lng})",
  },
  delivery: {
    read: "مقروء",
    delivered: "تم التسليم",
    queued: "في قائمة الانتظار",
    failed: "فشل",
    sent: "تم الإرسال",
  },
  errors: {
    genericSendFail: "تعذّر إرسال هذه الرسالة عبر WhatsApp.",
  },
  failureShort: {
    paymentIssue: "مشكلة دفع في حساب WhatsApp",
    cannotReceive: "لا يمكن للرقم استقبال WhatsApp",
    downloadFailed: "تعذّر على WhatsApp تنزيل الملف",
    templateMissingData: "بيانات القالب ناقصة",
    requirementsNotMet: "الرسالة لا تستوفي متطلبات WhatsApp",
  },
  failureTitle: {
    noWhatsapp: "بدون WhatsApp",
    invalidNumber: "رقم غير صالح",
    notSent: "لم يُرسَل",
  },
  alerts: {
    paymentIssue: "مشكلة دفع في WhatsApp",
    whatsappUnavailable: "WhatsApp غير متاح",
    qualityReduced: "جودة الرقم منخفضة",
  },
  toast: {
    reactivateNoConv: "تعذّر تحديد المحادثة لإعادة تفعيلها.",
    templateSent: "تم إرسال القالب بنجاح.",
    reactivateFail: "تعذّر إرسال قالب إعادة التفعيل.",
    cannotSendWhatsappTitle: "تعذّر الإرسال عبر WhatsApp",
    invalidPhoneDetail:
      "رقم هاتف هذا الحجز ({phone}) غير صالح. صحّحه في \"تعديل الحجز\" لتتمكن من مراسلته.",
    noPhoneDetail:
      "لا يوجد هاتف لهذا الحجز. أضِفه في \"تعديل الحجز\" لتتمكن من مراسلته.",
    sendErrorTitle: "خطأ في الإرسال",
    sendErrorDetail: "تعذّر إرسال الرسالة",
    errorTitle: "خطأ",
    copyLinkFail: "تعذّر نسخ الرابط",
    agentInactiveTitle: "وكيل الذكاء الاصطناعي غير نشط",
    agentInactiveDetail:
      "هذا العقار لا يملك وكيل الذكاء الاصطناعي نشطًا. فعّله من إعدادات القائمة.",
    noConvId: "تعذّر تحديد المحادثة",
    modeChangeFail: "تعذّر تغيير وضع المحادثة",
    agentUnavailableTitle: "وكيل الذكاء الاصطناعي غير متاح",
  },
};
